import { defineStore } from 'pinia';
import http from '../services/http'
import { ref } from 'vue'
import * as signalR from "@microsoft/signalr"
import { getTotalPages } from "../utils/helper"
import { ITEMS_PER_PAGE } from "../utils/constants"

var _hubConnection = null
var _hubStop = false

async function _hubStart() {
    try {
        await _hubConnection.start()
        // console.log("SignalR Connected.")
    } catch (err) {
        console.error(err)
        setTimeout(_hubStart, 10000)
    }
}

function setup() {
    function startHub() {
        if (_hubConnection == null) {
            _hubConnection = new signalR.HubConnectionBuilder()
                .withUrl(process.env.VUE_APP_SERVER + "apphub")
                .configureLogging(signalR.LogLevel.Information)
                .build()

            _hubConnection.onclose(async () => {
                if (!_hubStop) await _hubStart()
            })

            _hubConnection.on("NewMessage", (payload) => {
                messageCount.value++
                totalMessages.value++
                totalPages.value = getTotalPages(totalMessages.value, ITEMS_PER_PAGE)
                messages.value.unshift(payload)
            })
        }

        _hubStop = false
        _hubStart()
    }

    function stopHub() {
        if (_hubConnection) {
            _hubConnection.stop()
            _hubStop = true
        }
    }

    const messageCount = ref(0)
    const totalPages = ref(1)
    const totalMessages = ref(0)
    const reload = ref(true)
    const messages = ref([])

    async function loadMessageCount() {
        const result = await http.get('notifications/count')
        messageCount.value = result.count
    }

    async function loadMessages(page) {
        if (!reload.value) return

        const requireTotalRows = totalPages.value == 0

        const result = await http.post('notifications/query', {
            requireTotalRows,
            page: page ? page : 1
        })

        if (requireTotalRows) {
            totalMessages.value = result.totalRows
            totalPages.value = getTotalPages(totalMessages.value, ITEMS_PER_PAGE)
        }

        messages.value = result.items
        reload.value = false
    }

    async function changePage(page) {
        reload.value = true
        await loadMessages(page)
    }

    async function readMessage(index) {
        await http.put('notifications/' + messages.value[index].notificationId)
        if (messageCount.value > 0) messageCount.value--
        messages.value[index].read = true
    }

    async function deleteMessage(index) {
        await http.delete('notifications/' + messages.value[index].notificationId)
        if (!messages.value[index].read && messageCount.value > 0) messageCount.value--
        messages.value.splice(index, 1)

        if (totalMessages.value > 0) {
            totalMessages.value--
            totalPages.value = getTotalPages(totalMessages.value, ITEMS_PER_PAGE)
        }
    }

    return {
        messages,
        messageCount,
        totalPages,

        startHub,
        stopHub,
        loadMessageCount,
        loadMessages,
        readMessage,
        deleteMessage,
        changePage
    }
}

export const useNotificationStore = defineStore('notification', setup)
